import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=459434cc&scoped=true&"
import script from "./problem.vue?vue&type=script&lang=js&"
export * from "./problem.vue?vue&type=script&lang=js&"
import style0 from "./problem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./problem.vue?vue&type=style&index=1&id=459434cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459434cc",
  null
  
)

export default component.exports